var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            width: _vm.width,
            top: _vm.top,
            visible: _vm.dialogVisible,
            "append-to-body": _vm.toBody,
            "destroy-on-close": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: { close: _vm.dialogClose }
        },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }